export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-subscript-07c4ca627e3a10aa2cc41211d77a7c7d.svg";